<template>
  <div class="board-checkbox">
    <div class="form-check form-check-inline">
      <input :id="id" class="form-check-input" type="checkbox" :checked="value" @input="valueUpdated" :disabled="disabled" />
      <label :for="id" v-bind:class="labelStyle" class="form-check-label">{{ label }}</label>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop, Emit } from 'vue-property-decorator';
  import { uniqueId } from 'lodash';

  @Component
  export default class CheckboxWithLabel extends Vue {
    @Prop() value!: boolean;
    @Prop() label!: string;
    @Prop() labelStyle;
    @Prop() disabled!: boolean;
    private id = uniqueId();

    @Emit('input')
    valueUpdated(value: any) {
      return value.target.checked;
    }
  }
</script>

<style scoped lang="scss">
  .board-checkbox {
    label {
      font-weight: 600;
      color: #888 !important;
    }

    .regular {
      font-size: 12px;
    }

    :hover {
      cursor: pointer;
    }
  }
</style>
